import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] border-t border-[#FFDA00]/30 relative" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div data-testid="footer-brand">
            <h3
              className="text-3xl font-bold mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              <span className="text-[#FFDA00]">Rovèscio</span>
            </h3>
            <p className="text-gray-400 mb-4">Food & Lounge</p>
            <p className="text-sm text-gray-400">#VIVIALROVESCIO</p>
            <div className="flex gap-4 mt-6\">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#FFDA00] hover:text-white transition-colors font-medium text-sm"
                data-testid="footer-instagram-link"
              >
                Instagram
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#FFDA00] hover:text-white transition-colors font-medium text-sm"
                data-testid="footer-facebook-link"
              >
                Facebook
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-testid="footer-contact">
            <h4 className="text-xl font-bold text-white mb-4">Contatti</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-start gap-3">
                <MapPin className="text-[#FFDA00] mt-1 flex-shrink-0" size={18} />
                <div>
                  <p>Via Eschilo, 85</p>
                  <p>00125 Roma RM</p>
                  <p className="text-sm">Presso: Eschilo Sporting Village</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="text-[#FFDA00] flex-shrink-0" size={18} />
                <a href="tel:0696006258" className="hover:text-[#FFDA00] transition-colors">
                  06 9600 6258
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="text-[#FFDA00] flex-shrink-0" size={18} />
                <a
                  href="mailto:info@rovescio.it"
                  className="hover:text-[#FFDA00] transition-colors"
                >
                  info@rovescio.it
                </a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div data-testid="footer-hours">
            <h4 className="text-xl font-bold text-white mb-4">Orari di Apertura</h4>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-start gap-3">
                <Clock className="text-[#FFDA00] mt-1 flex-shrink-0" size={18} />
                <div>
                  <p className="font-semibold text-white">Lunedì - Domenica</p>
                  <p>12:00 - 15:00</p>
                  <p>19:00 - 23:00</p>
                  <p className="text-sm mt-2 text-gray-500">Prezzo medio: 20-30€ a persona</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="mb-8" data-testid="footer-map">
          <div className="w-full h-64 bg-[#2A2A2A] rounded overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2976.0765574023344!2d12.370118675898736!3d41.762007171254794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1325f395fd3f6f9d%3A0x772fe744c1421ff0!2sRovèscio - Food and Lounge!5e0!3m2!1sit!2sit!4v1785280278504!5m2!1sit!2sit"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Rovèscio Location"
            />
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Rovèscio - Food & Lounge. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
